export const rateStatus = {
  archived: "archived",
  draft: "draft",
  published: "published",
};
